export default __webpack_public_path__ + "static/lower2_1-0cbfb8dc36b934cb8f5004efb0b9151a.jpg";